<div style="height: 100%; width: 100%;" data-cy="non-working-days-container">
  <mat-grid-list cols="6" rowHeight="100%" style="height:100%;" data-cy="non-working-days-grid">
    <mat-grid-tile colspan="2" data-cy="non-working-days-regions-tile">
      <mat-card appearance="outlined" style="width:100%; height:100%;" data-cy="non-working-days-regions-card">
        <span class="configuration-section-title" data-cy="non-working-days-regions-title">Non Working Days</span>
        <mat-card-actions style="position: relative; top: -5px; left: 8px; width: 100%; border-bottom-style: inset; border-bottom-color: var(--tdo-primary);" data-cy="non-working-days-regions-actions">
          <button mat-button class="tdo-button tdo-save" (click)="onNew($event)" data-cy="non-working-days-new-button">New</button>
          <button [disabled]="true" mat-button class="tdo-button tdo-save" (click)="onDuplicate($event)" data-cy="non-working-days-duplicate-button">Duplicate</button>
          <button mat-button class="tdo-button tdo-save" *ngIf="selectedRegion" (click)="onNewYear($event)" data-cy="non-working-days-new-year-button">New Year</button>
        </mat-card-actions>

        <mat-card-content data-cy="non-working-days-regions-content">
          <app-tdo-table #regionTable *ngIf="regionTableModel !== undefined" [tdoTableModel]="regionTableModel"
                         (actionClick)="onTdoRegionTableItemActionClick($event)" (itemSelected)="onTdoRegionTableItemClick($event)" data-cy="non-working-days-regions-table"></app-tdo-table>
          <br />
          <app-tdo-table #yearTable *ngIf="selectedRegion !== undefined && nonWorkingDays !== undefined" [isSearchable]="false" [tdoTableModel]="yearTableModel"
                         (itemSelected)="onTdoYearTableItemClick($event)" data-cy="non-working-days-years-table"></app-tdo-table>
          <!--<dx-data-grid #regionGrid style="height:40%; margin-bottom: 10px;"
                        id="gridRegionNames"
                        [dataSource]="regionList"
                        keyExpr="WorkRegionID"
                        [hoverStateEnabled]="true"
                        [showBorders]="true"
                        (onSelectionChanged)="onRegionSelectionChanged($event)"
                        [selectedRowKeys]="[]">

            <dxo-selection mode="single"></dxo-selection>
            <dxo-editing mode="row" [allowDeleting]="true"></dxo-editing>
            <dxi-column dataField="WorkRegionID" caption="ID" [width]="0"></dxi-column>
            <dxi-column dataField="RegionName"></dxi-column>
          </dx-data-grid>

          <dx-data-grid *ngIf="selectedRegion && nonWorkingDaysObj"
                        #yearGrid style="height:40%"
                        id="gridRegionYears"
                        [dataSource]="nonWorkingDaysObj.YearList"
                        [hoverStateEnabled]="true"
                        [showBorders]="true"
                        (onSelectionChanged)="onYearSelectionChanged($event)"
                        [selectedRowKeys]="[]">

            <dxo-selection mode="single"></dxo-selection>
            <dxi-column dataField="NonWorkingYear" caption="Year" alignment="left" sortOrder="asc" [sortIndex]="0"></dxi-column>
          </dx-data-grid>-->
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>

    <!-- Adding new region -->
    <mat-grid-tile colspan="4" *ngIf="addingNew" data-cy="non-working-days-add-region-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="non-working-days-add-region-card">
        <span class="configuration-section-title" data-cy="non-working-days-add-region-title">Add New Region</span>
        <mat-card-actions style="position: relative; top: -5px; left: 8px; width: 100%; border-bottom-style: inset; border-bottom-color: var(--tdo-primary);" data-cy="non-working-days-add-region-actions">
          <button mat-button class="tdo-button tdo-save" (click)="onSaveNewRegion()" data-cy="non-working-days-save-region-button">Save</button>
          <button mat-button class="tdo-button tdo-close" (click)="onCancelNewRegion()" data-cy="non-working-days-cancel-region-button">Cancel</button>
        </mat-card-actions>

        <mat-card-content data-cy="non-working-days-add-region-content">
          <!-- Add new region name-->
          <mat-form-field style="width:100%" data-cy="non-working-days-region-name-field">
            <mat-label data-cy="non-working-days-region-name-label">Region Name</mat-label>
            <input matInput placeholder="New Zealand" [value]="newRegionName"
              (input)="newRegionName = $event.target.value" data-cy="non-working-days-region-name-input" />
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  
    <!-- Adding Non work days for region-->
    <mat-grid-tile colspan="4" *ngIf="!addingNew && selectedYear != -1 && nonWorkingDays" data-cy="non-working-days-detail-tile">
      <mat-progress-spinner *ngIf="isLoading" style="position: relative;" diameter="100" mode="indeterminate" data-cy="non-working-days-loading-spinner"></mat-progress-spinner>
      <mat-card appearance="outlined" style="width:100%; height:100%" *ngIf="!isLoading" data-cy="non-working-days-detail-card">
        <span class="configuration-section-title" data-cy="non-working-days-detail-title">Add Non Working Days</span>
        <mat-card-actions style="position: relative; top: -5px; left: 8px; width: 100%; border-bottom-style: inset; border-bottom-color: var(--tdo-primary);" data-cy="non-working-days-detail-actions">
          <button mat-button class="tdo-button tdo-save" (click)="onSaveNonWorkingDays()" data-cy="non-working-days-save-days-button">Save</button>
<!--          <button mat-button class="tdo-button tdo-save" [matMenuTriggerFor]="commonNonWorkingDayMenu">Add Common Non Working Days</button>-->
          <mat-menu #commonNonWorkingDayMenu="matMenu" data-cy="non-working-days-common-menu">
            <mat-selection-list #commonNonWorkingDays data-cy="non-working-days-common-list">
              <!-- the click event is for the context menu to not go away after a click -->
              <mat-list-option (click)="$event.stopPropagation()" value="Monday" [selected]="getIsCommonDaySelected('Monday')" data-cy="non-working-days-monday-option">Monday</mat-list-option>
              <mat-list-option (click)="$event.stopPropagation()" value="Tuesday" [selected]="getIsCommonDaySelected('Tuesday')" data-cy="non-working-days-tuesday-option">Tuesday</mat-list-option>
              <mat-list-option (click)="$event.stopPropagation()" value="Wednesday" [selected]="getIsCommonDaySelected('Wednesday')" data-cy="non-working-days-wednesday-option">Wednesday</mat-list-option>
              <mat-list-option (click)="$event.stopPropagation()" value="Thursday" [selected]="getIsCommonDaySelected('Thursday')" data-cy="non-working-days-thursday-option">Thursday</mat-list-option>
              <mat-list-option (click)="$event.stopPropagation()" value="Friday" [selected]="getIsCommonDaySelected('Friday')" data-cy="non-working-days-friday-option">Friday</mat-list-option>
              <mat-list-option (click)="$event.stopPropagation()" value="Saturday" [selected]="getIsCommonDaySelected('Saturday')" data-cy="non-working-days-saturday-option">Saturday</mat-list-option>
              <mat-list-option (click)="$event.stopPropagation()" value="Sunday" [selected]="getIsCommonDaySelected('Sunday')" data-cy="non-working-days-sunday-option">Sunday</mat-list-option>
            </mat-selection-list>
            <button mat-button class="tdo-button tdo-save" style="width: 100%" (click)="addCommonNonWorkingDays(commonNonWorkingDays.selectedOptions.selected)" data-cy="non-working-days-apply-common-button">Apply</button>
          </mat-menu>
          <button mat-button class="tdo-button tdo-save" (click)="clearYear()" data-cy="non-working-days-clear-year-button">Clear Year</button>
        </mat-card-actions>

        <mat-card-content data-cy="non-working-days-detail-content">
          <div data-cy="non-working-days-country-container">
            <div style="display:inline-block ; height: 48px; " data-cy="non-working-days-country-field-container"> 
              <span data-cy="non-working-days-country-label">Country:</span>
              <app-tdo-enum-select name="enumCountry" [validValueItemId]="selectedRegion.enumCountryID" (enumSelected)="onCountrySelected($event)" data-cy="non-working-days-country-select"></app-tdo-enum-select>
            </div>
          </div>
          <div data-cy="non-working-days-scheduler-container">
            <dx-scheduler #scheduler
                          [dataSource]="schedulerDataSource"
                          currentView="month"
                          [height]="550"
                          [useDropDownViewSwitcher]="false"
                          (onAppointmentClick)="overrideAppointmentClick($event)"
                          (onAppointmentDblClick)="overrideAppointmentDblClick($event)"
                          (onAppointmentFormOpening)="overrideAppointmentFormOpening($event)"
                          (onCellClick)="overrideCellClick($event)"
                          (onInitialized)="initScheduler()"
                          [min]="minDate"
                          [max]="maxDate"
                          [currentDate]="minDate"
                          [appointmentDragging]="false"
                          [views]="['day', 'week', 'month']"
                          recurrenceEditMode="occurrence"
                          data-cy="non-working-days-scheduler">
            </dx-scheduler>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

